import { render, staticRenderFns } from "./ChooseForm.vue?vue&type=template&id=8b8b57ae&scoped=true&"
import script from "./ChooseForm.vue?vue&type=script&lang=js&"
export * from "./ChooseForm.vue?vue&type=script&lang=js&"
import style0 from "./ChooseForm.vue?vue&type=style&index=0&id=8b8b57ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8b57ae",
  null
  
)

export default component.exports